module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/crocodile-mobile.0dde5e61.png";